import { format } from "d3-format";
import React, { Component } from "react";
import PropTypes from "prop-types";
import GenericChartComponent from "../GenericChartComponent";
import ToolTipText from "./ToolTipText";
import ToolTipTSpanLabel from "./ToolTipTSpanLabel";
import { functor, isDefined } from "../utils";

class HHVTooltip extends Component {
  constructor(props) {
    super(props);
    this.renderSVG = this.renderSVG.bind(this);
  }

  renderSVG(moreProps) {
    const {
      onClick,
      fontFamily,
      fontSize,
      yAccessor,
      displayFormat,
      origin: originProp,
      options,
      appearance,
    } = this.props;

    const {
      chartConfig: { width, height },
    } = moreProps;
    const { currentItem } = moreProps;

    if (!isDefined(currentItem)) return null;

    const value = yAccessor(currentItem);
    if (!isDefined(value)) return null;

    const period = options.period || 14;
    const valueFormatted = displayFormat(value);

    const origin = functor(originProp);
    const [x, y] = origin(width, height);

    const strokeColor = appearance?.stroke?.color || "#4CAF50";

    return (
      <g
        transform={`translate(${x}, ${y})`}
        onClick={onClick}
        data-evo-id="tooltip-hhv"
      >
        <ToolTipText x={0} y={0} fontFamily={fontFamily} fontSize={fontSize}>
          <ToolTipTSpanLabel fill="#FFFFFF">
            {`HHV (${period}): `}
          </ToolTipTSpanLabel>
          <tspan fill={strokeColor}>{valueFormatted}</tspan>
        </ToolTipText>
      </g>
    );
  }

  render() {
    return (
      <GenericChartComponent
        clip={false}
        svgDraw={this.renderSVG}
        drawOn={["mousemove"]}
      />
    );
  }
}

HHVTooltip.propTypes = {
  origin: PropTypes.oneOfType([PropTypes.array, PropTypes.func]).isRequired,
  className: PropTypes.string,
  fontFamily: PropTypes.string,
  fontSize: PropTypes.number,
  onClick: PropTypes.func,
  yAccessor: PropTypes.func.isRequired,
  displayFormat: PropTypes.func.isRequired,
  options: PropTypes.shape({
    period: PropTypes.number,
  }).isRequired,
  appearance: PropTypes.shape({
    stroke: PropTypes.shape({
      color: PropTypes.string,
    }),
  }),
};

HHVTooltip.defaultProps = {
  displayFormat: format(".2f"),
  origin: [0, 0],
  className: "react-stockcharts-tooltip",
};

export default HHVTooltip;
